import { useInView } from '../hooks';
import styles from './Roadmap.module.css';

function RoadmapItem({ phase, title, items, done, delay }) {
  const [ref, inView] = useInView(0.2);
  return (
    <div
      ref={ref}
      className={styles.item}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'none' : 'translateY(18px)',
        transition: `all 0.6s ease ${delay}s`,
      }}
    >
      <div
        className={styles.dot}
        style={{
          background: done ? '#06B6D4' : 'transparent',
          borderColor: done ? '#06B6D4' : 'rgba(59,130,246,0.4)',
          boxShadow: done ? '0 0 14px rgba(6,182,212,0.7)' : 'none',
        }}
      />
      <div className={styles.content}>
        <div className={styles.phase} style={{ color: done ? '#06B6D4' : '#4B5563' }}>{phase}</div>
        <h4 className={styles.itemTitle}>{title}</h4>
        <ul className={styles.list}>
          {items.map((item, i) => (
            <li key={i} className={styles.listItem}>
              <span style={{ color: done ? '#06B6D4' : '#374151' }}>
                {done ? '✓' : '·'}
              </span>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default function Roadmap({ t }) {
  const [ref, inView] = useInView(0.1);

  const phases = [
    { phase: t.phase1Label, title: t.phase1Title, items: t.phase1Items, done: true,  delay: 0    },
    { phase: t.phase2Label, title: t.phase2Title, items: t.phase2Items, done: true,  delay: 0.15 },
    { phase: t.phase3Label, title: t.phase3Title, items: t.phase3Items, done: false, delay: 0.3  },
  ];

  return (
    <section className={styles.section} id="roadmap">
      <div className={styles.inner}>
        <div
          ref={ref}
          style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(16px)', transition: 'all 0.6s ease' }}
        >
          <div className={styles.label}>{t.sectionLabel}</div>
          <h2 className={styles.title}>{t.title}</h2>
          <p className={styles.sub}>{t.sub}</p>
        </div>

        <div className={styles.grid}>
          {/* horizontal connector */}
          <div className={styles.connector} />
          {phases.map(p => <RoadmapItem key={p.phase} {...p} />)}
        </div>
      </div>
    </section>
  );
}
